import { styles } from './CarouselLeadImage.css';
import React, { ReactNode } from 'react';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { ProductCarousel, ProductCarouselProps } from '../ProductCarousel/ProductCarousel';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { GoToLink, GoToLinkProps } from '../GoToLink/GoToLink';

export type CarouselLeadImageProps = {
  desktopImage?: ReactNode;
  mobileImage?: ReactNode;
  linkProps?: GoToLinkProps;
  ctaButton?: ReactNode;
  heading: string;
  subText?: string;
  isWhiteSubText?: boolean;
  productCarouselProps: ProductCarouselProps;
  shouldHideHeadingOnMobile?: boolean;
};

export const CarouselLeadImage = ({
  desktopImage,
  mobileImage,
  linkProps,
  ctaButton,
  heading,
  subText,
  isWhiteSubText,
  productCarouselProps,
  shouldHideHeadingOnMobile,
}: CarouselLeadImageProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  const hasRelevantImage = isDesktop ? !!desktopImage : !!mobileImage;

  return (
    <div className={styles.wrapper}>
      {linkProps && isDesktop ? <GoToLink {...linkProps} className={styles.link} /> : null}
      <div className={styles.container({ hasImage: hasRelevantImage })}>
        {hasRelevantImage ? (
          <div className={styles.imageContainer}>{isDesktop ? desktopImage : mobileImage}</div>
        ) : null}
        {shouldHideHeadingOnMobile && !isDesktop ? null : (
          <div className={styles.leadContainer({ hasImage: hasRelevantImage })}>
            <DomFont as="h1" className={styles.headingText({ hasImage: hasRelevantImage })}>
              {heading}
            </DomFont>
            {subText ? <p className={styles.subText({ isWhiteSubText })}>{subText}</p> : null}
            {isDesktop && ctaButton && !!desktopImage ? <div className={styles.ctaButton}>{ctaButton}</div> : null}
          </div>
        )}
        <div className={styles.carouselContainer}>
          <ProductCarousel {...productCarouselProps} />
        </div>
      </div>
      {ctaButton && (!isDesktop || !desktopImage) ? <div className={styles.bottomCtaButton}>{ctaButton}</div> : null}
    </div>
  );
};
